<template>
  <div class="header">
    <!-- 본인인증 폼 -->
    <form action="" target="nice" method="post" ref="form">
      <input type="hidden" name="m" value="">
      <input type="hidden" name="EncodeData" value="">
    </form>
    <form action="" target="niceipin" method="post" ref="ipinForm">
      <!-- 아이핀 폼 -->
      <input type="hidden" name="enc_data">
      <input type="hidden" name="m" value="">
    </form>
    <form action="" target="raon" method="post" ref="raonForm">
      <!-- 본인실명확인서비스 요청 form -->
      <input type="hidden" name="certInfo" />
      <input type="hidden" name="cpParam" />
      <input type="hidden" name="nr" />
    </form>
    <br/><br/>
    <button @click="requestNiceIPINCert">
      아이핀 인증
    </button>

    <br/><br/>

    <button @click="requestRaonCert">
      신용카드 인증
    </button>
    <br/><br/>

    <button @click="requestNiceCert">
      나이스 휴대폰 인증
    </button>
    <br/><br/>

    <input v-model="email" placeholder="소속 회사 이메일">
    <span class="ms-1">@</span>
    <select id="options" v-model="emailDomain">
      <option value="eznwellness.com">eznwellness.com</option>
    </select>

    <button @click="handleClickEmailCertBtn">
      인증번호 발송
    </button>

    <template v-if="showEmailCertTimer">
      <input v-model="certEmailNumber" placeholder="인증번호">

      <button @click="confirmCertEmailNumber">
        인증번호 확인
      </button>
    </template>
  </div>
</template>

<script>
import store from '@/store'
import Util from '@/utils/utils'
let popup

const USER_AUTH_TYPE_CODES = {
  IDENTIFICATION: {
    code: 'IDENTIFICATION'
  },
  IPIN: {
    code: 'IPIN'
  },
  EMAIL: {
    code: 'EMAIL'
  },
  CARD: {
    code: 'CARD'
  }
}

export default {
  name: 'CertTest',
  components: {},
  mixins: [],
  props: {},
  data: () => ({
    emailDomain: null,
    email: null,
    showEmailCertTimer: false,
    certEmailNumber: '', // 인증번호
    certifySession: null,
  }),
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    window.niceCertSuccess = this.certSuccess
  },
  methods: {
    handleClickEmailCertBtn () {
      if (Util.Common.isNullValue(this.email)) {
        this.$alert('이메일을 입력하세요.')
        return
      }

      // eslint-disable-next-line no-useless-escape
      const emailReg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/
      if (!emailReg.test(this.email + '@' + this.emailDomain)) {
        this.$alert('이메일 형식이 올바르지 않습니다.')
        return
      }

      this.requestAuthEmail()
    },
    async requestAuthEmail () {
      this.certEmailNumber = null
      const params = {
        clientId: store.state.auth.authUser.clientId,
        email: this.email + '@' + this.emailDomain
      }
      await store.dispatch('postSendEmailCertificationNumber', this.$_payload(null, params))
          .then(res => {
            if (res.success) {
              this.showEmailCertTimer = true
              this.certifySession = res.data
            } else {
              this.$alert(res.msg)
            }
          })
    },

    async confirmCertEmailNumber () {
      const params = {
        savedSessionName: this.certifySession,
        number: this.certEmailNumber,
        userAuthTypeCode: 'EMAIL'
      }
      store.dispatch('postConfirmEmailCertificationNumber', this.$_payload(null, params))
          .then(res => {
            if (res.success) {
              this.showEmailCertTimer = false
              this.verifyEmail = true
              this.$alert('인증이 완료되었습니다.').then(() => {
                window.location.href = '/'
              })
            } else {
              this.$alert(res.msg)
            }
          })
    },


    requestNiceCert () {
      this.openNiceCertPopup('form', 'nice')
    },
    requestNiceIPINCert () {
      this.openNiceIPINPopup('ipinForm', 'niceipin')
    },
    requestRaonCert () {
      this.openRaonPopup('raonForm', 'raon')
    },


    makeNiceCertPopupFeatures () {
      const width = 500
      const height = 550

      const pos = {
        x: (screen.width / 2) - (width / 2),
        y: (screen.height / 2) - (height / 2)
      }

      return `width=${width} height=${height} left=${pos.x} top=${pos.y} fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no`
    },
    getNiceEncryptData () {
      const params = [
        { userAuthTypeCode: USER_AUTH_TYPE_CODES.IDENTIFICATION.code },
        { redirectUrl: store.state.auth.baseURL + '/user' }
      ]

      return store.dispatch('getNiceEncryptData', this.$_payload(null, params))
    },
    getNiceIPINEncryptData () {
      const params = [
        { userAuthTypeCode: USER_AUTH_TYPE_CODES.IPIN.code },
        { redirectUrl: store.state.auth.baseURL + '/user' }
      ]

      return store.dispatch('getNiceIPINEncryptData', this.$_payload(null, params))
    },
    openNiceIPINPopup (formId, target) {
      this.getNiceIPINEncryptData()
          .then(res => {
            if (res.success) {
              const features = this.makeNiceCertPopupFeatures()

              this.$refs[formId].action = res.data.actionUrl
              this.$refs[formId].m.value = res.data.moduleId
              this.$refs[formId].enc_data.value = res.data.encryptKey

              window.open('', target, features)

              this.$refs[formId].submit()

              window.focus()
            } else {
              let msg = res.msg ? res.msg : '데이터 조회에 실패했습니다. 다시 시도해주세요.'
              this.$alert(msg)
            }
          })
    },
    openNiceCertPopup (formId, target) {
      this.getNiceEncryptData()
          .then(res => {
            if (res.success) {
              const features = this.makeNiceCertPopupFeatures()

              this.$refs[formId].action = res.data.actionUrl
              this.$refs[formId].m.value = res.data.moduleId
              this.$refs[formId].EncodeData.value = res.data.encryptKey

              window.open('', target, features)

              this.$refs[formId].submit()

              window.focus()
            } else {
              let msg = res.msg ? res.msg : '데이터 조회에 실패했습니다. 다시 시도해주세요.'
              this.$alert(msg)
            }
          })
    },
    getRaonEncryptData () {
      const params = [
        { userAuthTypeCode: 'CARD' },
        { redirectUrl: store.state.auth.baseURL + '/user' }
      ]
      return store.dispatch('getRaonCertInfo', this.$_payload(null, params))
    },
    openRaonPopup(formId, target) {
      this.getRaonEncryptData()
          .then(res => {
            if (res.success) {
              let winOpts = 'width=430px, height=725px, scrollbars=yes, resizable=yes, menubar=no, toolbar=no, location=no, status=no, titlebar=0,'
              let position = ',left=10px, top=10px'

              this.$refs[formId].action = res.data.certUrl
              this.$refs[formId].certInfo.value = res.data.certInfo
              this.$refs[formId].cpParam.value = res.data.cpParam
              this.$refs[formId].nr.value = res.data.nr

              if (popup) {
                popup.close()
              }
              popup = window.open('', target, winOpts + position)

              this.$refs[formId].submit()

              window.focus()
            } else {
              let msg = res.msg ? res.msg : '데이터 조회에 실패했습니다. 다시 시도해주세요.'
              this.$alert(msg)
            }
          })
    },
    certSuccess (response) {
      const params = {
        ...response,
        requestType: 'JOIN_USER'
      }

      let action = ''
      switch (params.userAuthTypeCode) {
        case 'IDENTIFICATION':
          action = 'identityVerificationSuccess'
          break
        case 'IPIN':
          action = 'IPINSuccess'
          break
        case 'CARD':
          action = 'creditCardSuccess'
          break
        default:
          return false
      }
      store.dispatch(action, this.$_payload(null, params))
          .then(res => {
            if (res.success) {
              this.$alert('본인인증 성공')
            } else {
              this.$alert(res.msg ? res.msg : '데이터 통신중 오류 발생. 다시 시도해주세요.')
            }
          })

    }
  }
}
</script>

<style scoped>
</style>
